"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * JavascriptLoader.
 */
var JavascriptLoader = /** @class */ (function () {
    /**
     *
     * @param url Url to script file.
     */
    function JavascriptLoader(url) {
        this.element = document.createElement('script');
        this.element.src = url;
    }
    /**
     * Load a script by adding a script tag.
     *
     * @returns Promise event.
     */
    JavascriptLoader.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.element.addEventListener('load', resolve);
            _this.element.addEventListener('error', reject);
            _this.element.async = true;
            document.head.appendChild(_this.element);
        });
    };
    return JavascriptLoader;
}());
exports.default = JavascriptLoader;
//# sourceMappingURL=JavascriptLoader.js.map